import React, { createContext, useEffect, useState } from 'react'

interface DarkModeProviderProps {
  children: React.ReactNode
}

interface DarkModeContextType {
  isDarkMode: boolean
  toggleDarkMode: () => void
}

export const DarkModeContext = createContext<DarkModeContextType>({
  isDarkMode: false,
  toggleDarkMode: () => {},
})

export function DarkModeProvider({
  children,
}: DarkModeProviderProps): React.JSX.Element {
  // If local preference is not set, set it to true
  if (localStorage.getItem('dark-mode') === null) {
    localStorage.setItem('dark-mode', 'true')
  }

  // Get preference from local storage
  const localPreference = localStorage.getItem('dark-mode')

  const [isDarkMode, setIsDarkMode] = useState(localPreference === 'true')

  const toggleDarkMode = () => {
    setIsDarkMode(prevMode => !prevMode)
  }

  useEffect(() => {
    // Bootstrap 5.3 / AdminLTE 4 theme switch; index.html applies the saved value before first paint.
    document.documentElement.setAttribute('data-bs-theme', isDarkMode ? 'dark' : 'light')

    localStorage.setItem('dark-mode', (isDarkMode).toString())
  }, [isDarkMode])

  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  )
}
